import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Custom Digital Solutions Crafted Exclusively For Your Business
              </h2>
            </div>
            <p>
              TekRevol is a top-rated New York software development company
              helping enterprises build mobile solutions that support their
              brand identity, meet market needs, and encourage business growth
              and expansion. Our professional software developers in NYC are
              experienced enough to create cutting-edge digital solutions –
              backed with recent technologies & frameworks.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
